// Safely resolve a human-readable string from any error-like shape.
// Handles: plain strings, Error objects, Axios errors, Redux-rejected payloads,
// backend i18n objects like { en: "...", fr: "..." }, and nested combinations.
// Returns `fallback` when nothing usable is found, and never returns "[object Object]".
export const extractErrorMessage = (source, fallback = '', lang = 'en') => {
    if (source === null || source === undefined) return fallback;

    if (typeof source === 'string') {
        // Guard against already-stringified objects making it here
        if (source === '[object Object]') return fallback;
        return source;
    }

    if (typeof source !== 'object') return fallback;

    // Axios error shape: { response: { data: { message } } }
    if (source.response?.data) {
        const fromResponse = extractErrorMessage(source.response.data, '', lang);
        if (fromResponse) return fromResponse;
    }

    // Backend payload shape: { message, error, ... }
    if (source.message !== undefined && source.message !== null) {
        const fromMessage = extractErrorMessage(source.message, '', lang);
        if (fromMessage) return fromMessage;
    }

    if (source.error !== undefined && source.error !== null) {
        const fromError = extractErrorMessage(source.error, '', lang);
        if (fromError) return fromError;
    }

    // Localised object: { en: "...", fr: "...", ... }
    if (typeof source[lang] === 'string' && source[lang]) return source[lang];
    if (typeof source.en === 'string' && source.en) return source.en;

    const firstString = Object.values(source).find(
        (v) => typeof v === 'string' && v && v !== '[object Object]'
    );
    if (firstString) return firstString;

    return fallback;
};
